"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/*:: import { type ThemeType, type InjectSheetProvidedProps } from '../../style/ThemeTypes';*/
/*:: type Props = InjectSheetProvidedProps & {
  children?: React.Node,
  'data-testid'?: string,
  forwardedRef: React.Ref<'div'>
};*/
var Style = function Style(theme /*: ThemeType*/) {
  return {
    root: (0, _defineProperty2.default)((0, _defineProperty2.default)({
      display: 'flex',
      flexShrink: 0,
      alignItems: 'center',
      width: '100%'
    }, theme.breakpoints.gte.tablet.portrait, {
      width: 'auto'
    }), '& > *', {
      marginLeft: '0.5rem',
      '&:first-child': {
        marginLeft: 0
      }
    })
  };
};
var PageHeaderButtonGroup = function PageHeaderButtonGroup(_ref /*:: */) {
  var children = _ref /*:: */.children,
    classes = _ref /*:: */.classes,
    className = _ref /*:: */.className,
    dataTestId = _ref /*:: */['data-testid'],
    forwardedRef = _ref /*:: */.forwardedRef;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(classes.root, className),
    "data-testid": dataTestId,
    ref: forwardedRef
  }, children);
};
PageHeaderButtonGroup.displayName = 'PageHeaderButtonGroup';
var EnhancedPageHeaderButtonGroup = (0, _injectSheet.default)(Style)(PageHeaderButtonGroup);
var EnhancedPageHeaderButtonGroupWithRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(EnhancedPageHeaderButtonGroup, (0, _extends2.default)({}, props, {
    forwardedRef: ref
  }));
});
EnhancedPageHeaderButtonGroupWithRef.displayName = 'EnhancedPageHeaderButtonGroupWithRef';
var _default = exports.default = EnhancedPageHeaderButtonGroupWithRef;
//# sourceMappingURL=PageHeaderButtonGroup.js.map